import reactstrapCjs from "reactstrap";
import React from "react";
import KickImage from 'Reuseables/KickImage';
import styled from "styled-components";
import ConButton from "../../../images/hermes-luxury-btn.png"
import DesktopBackground from "../../../images/concierge-entry-desktop.png"
import ConciergeMobile from "../../../images/concierge-mobile.png"
import ArrowRight from "../../../images/arrow-right.png"
import { withRouter, history, Link } from "react-router-dom"

const LuxuryConcierge = ({ history }) => {

  const { availWidth } = window.screen

  return (
    <LuxuryConciergeWrapper style={{ backgroundImage: availWidth > 480 ? `url(${DesktopBackground})` : `url(${ConciergeMobile})`, backgroundPosition: "bottom", backgroundSize: "cover" }}>
      <Link
        to={`/luxury/concierge`}
        target="_blank"
        className="editors-release-style"
      >
        <KickImage className="handbags-entry-concierge" src={ConButton} alt="handbags" />
        <div>
          <h4>Concierge Service</h4>
          <h6>Let us know about your wishlist and we can find the best deal just for you!</h6>
        </div>
        <KickImage className="concierge-arrow-right" src={ArrowRight} alt="arrow" />
      </Link>
    </LuxuryConciergeWrapper>
  )
}

const LuxuryConciergeWrapper = styled.div`
  a{
    width: 100%;
    display: flex;
    align-items: center;
    .concierge-arrow-right{
    width: 10px;
    height: auto;
    margin-left: auto;
    margin-right: 40px;
  }
    .handbags-entry-concierge{
    width: 65px;
    heigth: auto;
    margin: 0 20px 0 30px;
  }
  div{
    h4 {
    font-size: 20px;
    color: #FFF;
    font-family: Nunito Bold;
    text-align: left;
    margin-bottom: 0.5rem;  
    }
    h6 {
      color: #ffffff;
      font-size: 16px;
      font-family: Nunito;
      text-align: left;
      font-weight: normal;
    }
  }
  }
  height: auto;
  width: 90%;
  cursor: pointer;
  padding: 28px 0;
  border: solid 1px #707070;
  background-color: #242424;
  border-radius: 5px;
  transition: transform 0.2s;
  margin: 0px auto 50px auto;

  &:hover {
    transform: scale(1.05) ;
  }

  @media (min-width: 320px) and (max-width: 480px){
  a {
    .concierge-arrow-right{
    width: 10px;
    height: auto;
    margin-left: 20px;
    margin-right: 10px;
  }
  .handbags-entry-concierge{
    width: 65px;
    heigth: auto;
    margin: 0 10px 0 5px;
  }
  p {
      font-size: 12px;
  }
  div {
    h4 {
      font-size: 12px;
      }
      h6 {
        font-size: 10px;
      }
    }
  }
    &:hover, &:active {
      transform: scale(1.05s);
    }
    padding: 10px;
    transition: transform 0.2s;
  }
`

export default (withRouter(LuxuryConcierge));